import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {PLACEHOLDER_IMAGE_URL} from "../../../../app/mock/constants";
import {useAuth} from "../../../../app/modules/auth";
import imgBaseUrl from '../../../../app/utils/imgBaseUrl';

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()

  return (
      <div className='app-navbar flex-shrink-0'>

        {/*<div className={clsx('app-navbar-item', itemClass)}>*/}
        {/*  <div*/}
        {/*      data-kt-menu-trigger="{default: 'click'}"*/}
        {/*      data-kt-menu-attach='parent'*/}
        {/*      data-kt-menu-placement='bottom-end'*/}
        {/*      className={"position-relative btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px"}*/}
        {/*  >*/}

        {/*    {true && (*/}
        {/*        <span*/}
        {/*            className="bullet bullet-dot bg-success h-6px w-6px position-absolute top-0 translate-middle start-50 animation-blink"></span>*/}
        {/*    )}*/}

        {/*    <KTIcon iconName='message-text-2' className={btnIconClass}/>*/}
        {/*  </div>*/}
        {/*  <HeaderNotificationsMenu notifications={[{is_read: true, title: "Salom", text: "sdadas"}]}/>*/}
        {/*</div>*/}

        <div className={clsx('app-navbar-item', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')}/>
        </div>


        <div className={clsx('app-navbar-item', itemClass)}>
          <div
              className={clsx('cursor-pointer symbol', userAvatarClass)}
              data-kt-menu-trigger="{default: 'click'}"
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
          >
            <img className={"object-fit-cover"} src={imgBaseUrl(currentUser?.avatar!) || PLACEHOLDER_IMAGE_URL} alt=''/>
          </div>
          <HeaderUserMenu/>
        </div>
      </div>
  )
}

export {Navbar}
